import { ApiCorrectAnswerItem, CorrectAnswerValueItem } from '@models/CorreectAnswerDetailsModel';

export function toApiCorrectAnswerItem<T extends { value?: string; correctAnswers?: CorrectAnswerValueItem[] }>(
  item: T
): Omit<T, 'value' | 'correctAnswers'> & { answers?: CorrectAnswerValueItem[] } {
  const { value, correctAnswers, ...rest } = item;
  if (correctAnswers !== undefined) {
    return { ...rest, answers: correctAnswers };
  }
  if (value !== undefined && value !== null) {
    return { ...rest, answers: [{ value }] };
  }
  return rest;
}

export function fromApiCorrectAnswerItems(items: ApiCorrectAnswerItem[] | undefined): CorrectAnswerValueItem[] {
  return (items ?? [])
    .map((item): CorrectAnswerValueItem | null => {
      if (item.correctAnswerId !== null && item.correctAnswerId !== undefined) {
        return { answerId: item.correctAnswerId };
      }
      if (item.correctAnswer !== null && item.correctAnswer !== undefined) {
        return { value: item.correctAnswer };
      }
      return null;
    })
    .filter((item): item is CorrectAnswerValueItem => item !== null);
}

export function withMappedCorrectAnswers<T extends { correctAnswer?: string; correctAnswers?: ApiCorrectAnswerItem[] }>(
  question: T
): Omit<T, 'correctAnswers'> & { correctAnswers: CorrectAnswerValueItem[] } {
  const correctAnswers = fromApiCorrectAnswerItems(question.correctAnswers);
  const correctAnswer = question.correctAnswer ?? correctAnswers[0]?.value;
  return { ...question, correctAnswer, correctAnswers };
}
